/* eslint-disable import/extensions */
import React, { useCallback, useEffect, useState } from 'react';

import { Avatar, Button, Grid, Tooltip, Typography } from '@mui/material';
import { useAccount } from 'wagmi';

import { searchNFTsAPI } from '@/api/getSearchedNFTs';
import { searchTokensAPI } from '@/api/getSearchedTokens';
import { Popup } from '@/components/Popup/Popup';
import { Spinner } from '@/components/Spinner/Spinner';
import useMediaQuery from '@/hooks/useMediaQuery';
import { GetTokenResponse, IGetNFTResponse } from 'interfaces/ApiType/apiType';
import { ISelectTokenScreenProps } from 'interfaces/UserNftAndToken/userNftToken';
import arrDwn from 'public/assets/arrowDown.svg';

import NetworkMenu from './NetworkMenu';
import NetworkMenuList from './NetworkMenuList';

const SelectTokenScreen = ({
  userNetworkName,
  setUserNetworkName,
  SelectTokenDiv,
  isSelectTokenScreenActive,
  selectToken,
  selectNft,
}: ISelectTokenScreenProps) => {
  const [inputToken, setInputToken] = useState('');
  const [isRequestLoading, setRequestLoading] = useState(false);
  const [searchedTokens, setTokens] = useState<any>();
  const [searchedNfts, setNfts] = useState<any>();
  const [isNetworkMenuVisible, setIsNetworkMenuVisible] = useState(false);
  const isMediaMax1025px = useMediaQuery('(max-width : 1025px)');
  const { data: signer } = useAccount();
  const getTokens = useCallback(
    async (str: string, network: string) => {
      try {
        setRequestLoading(true);
        const resp: GetTokenResponse = await searchTokensAPI({
          account: signer?.address,
          search: str,
          network,
        });
        if (resp) {
          setTokens(resp);
          setRequestLoading(false);
        }
      } catch (err) {
        // setError(true);
      }
    },
    [signer?.address]
  );

  // Get User Nfts
  const getNfts = useCallback(
    async (str: string, network: string) => {
      try {
        setRequestLoading(true);
        const resp: IGetNFTResponse = await searchNFTsAPI({
          account: signer?.address,
          search: str,
          network,
        });
        if (resp) {
          setNfts(resp);
          setRequestLoading(false);
        }
      } catch (err) {
        // setError(true);
      }
    },
    [signer?.address]
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      getNfts(inputToken, userNetworkName.toLowerCase());
      getTokens(inputToken, userNetworkName.toLowerCase());
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [inputToken]);

  useEffect(() => {
    getNfts(null, userNetworkName.toLowerCase());
    getTokens(null, userNetworkName.toLowerCase());
  }, [getNfts, getTokens, userNetworkName]);
  return (
    <Popup
      isOpen={isSelectTokenScreenActive}
      width={isMediaMax1025px ? null : '444px'}
      height={isMediaMax1025px ? '32rem' : '75%'}
      margin={isMediaMax1025px ? '70px 5%' : '70px auto'}
      closePopup={() => {}}
    >
      <div
        ref={SelectTokenDiv}
        className="h-full no-scrollbar overflow-y-scroll w-full box-border"
      >
        <div className="flex mb-8">
          <div className="flex items-center w-[70%] ">
            <div className="flex text-heading w-full pr-4 items-center font-semibold">
              <input
                placeholder="Search name or paste address"
                value={inputToken}
                className="input-box text-sm"
                onChange={(e) => setInputToken(e.target.value)}
              />
            </div>
          </div>
          <div className="relative w-[30%] flex items-center">
            <button
              onClick={() => setIsNetworkMenuVisible(!isNetworkMenuVisible)}
              className="border w-[100%] h-10 rounded-lg bg-yellow border-black p-3 text-[13px] items-center flex col-start-4 text-black leading-3  align-center justify-around"
            >
              {userNetworkName}
              <img
                className={`${
                  isNetworkMenuVisible ? 'rotate-180' : ''
                } ml-2 w-[10px] h-[10px] rounded-lg `}
                alt=""
                src={arrDwn.src}
              />
            </button>
            <div className={` absolute z-10 bg-white w-[100%] top-14 right-0`}>
              {isNetworkMenuVisible && (
                <NetworkMenu>
                  <NetworkMenuList
                    getNfts={getNfts}
                    getTokens={getTokens}
                    setIsNetworkMenuVisible={setIsNetworkMenuVisible}
                    networkName="Ethereum"
                    setUserNetworkName={setUserNetworkName}
                  />
                  <NetworkMenuList
                    getNfts={getNfts}
                    getTokens={getTokens}
                    networkName="Polygon"
                    setIsNetworkMenuVisible={setIsNetworkMenuVisible}
                    setUserNetworkName={setUserNetworkName}
                    isLastOnTheList
                  />
                </NetworkMenu>
              )}
            </div>
          </div>
        </div>
        <div
          className={`flex text-default my-[7px] font-semibold ${
            isRequestLoading ? 'mb-[10px]' : 'mb-[32px]'
          } mt-[12px]`}
        >
          Tokens
        </div>
        {isRequestLoading ? (
          <div>
            <Spinner />
          </div>
        ) : (
          <div className="flex mb-[25px] ml-[16px]">
            <Grid
              container
              spacing={2}
              gap={1}
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              {searchedTokens &&
                (searchedTokens.length === 0 ? (
                  <h4 className="text-sm">No Tokens</h4>
                ) : (
                  searchedTokens.map((token: any, index: number) => (
                    <Tooltip
                      title={'jsohsuus'}
                      key={index}
                      placement={'top-start'}
                    >
                      <div>
                        <Button
                          variant="outlined"
                          key={index}
                          onClick={() => selectToken(token)}
                          style={{
                            borderRadius: 8,
                            backgroundColor: '#ffffff',
                            border: '1px solid grey',
                          }}
                          className={`w-[120px] flex justify-evenly `}
                          disableElevation={false}
                          startIcon={
                            <Avatar className="w-8 h-8" src={token.thumbnail} />
                          }
                        >
                          <Typography className="" style={{ color: 'black' }}>
                            {token.symbol.length > 5
                              ? `${token.symbol.substring(0, 3)}...`
                              : token.symbol}
                          </Typography>
                        </Button>
                      </div>
                    </Tooltip>
                  ))
                ))}
            </Grid>
          </div>
        )}

        <div className="flex text-default mt-[20px] mb-[32px] font-semibold">
          NFTs
        </div>
        {isRequestLoading ? (
          <div>
            <Spinner />
          </div>
        ) : (
          <div className="flex mb-[25px] ml-[16px]">
            <Grid
              container
              spacing={2}
              gap={1}
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              {searchedNfts &&
                (searchedNfts.length === 0 ? (
                  <h4 className="text-sm">No Nfts</h4>
                ) : (
                  searchedNfts.map((nft: any) => (
                    <div
                      key={`nft-${nft.name}`}
                      id="show_bg_2"
                      className="w-[110px] h-[110px] text-white flex rounded hover:cursor-pointer"
                      onClick={() => selectNft(nft)}
                      style={{
                        backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255,0), rgba(10, 10, 10, 0.73)), url(${nft.image})`,
                        backgroundSize: 'cover',
                      }}
                    >
                      <span className="mt-auto mb-2 ml-2 font-bold">
                        {nft.symbol.length > 10
                          ? `${nft.symbol.substring(0, 7)}...`
                          : nft.symbol}
                      </span>
                    </div>
                  ))
                ))}
            </Grid>
          </div>
        )}
      </div>
    </Popup>
  );
};

export default SelectTokenScreen;
